import React, { CSSProperties, PropsWithChildren } from "react";

interface StyledParagraphProps {
    Style?: CSSProperties
}

const PARAGRAPHSTYLE: CSSProperties = {
    color: '#fff',
    lineHeight: 1.2,
    fontSize: '1.2rem',
    fontWeight: 400,
    margin: '2rem auto 0',
}

const StyledParagraph: React.FC<PropsWithChildren<StyledParagraphProps>> = props => {
    return(
        <p style={props.Style || PARAGRAPHSTYLE}>{props.children}</p>
    )
}

export default StyledParagraph